@if (productDetails().length === 0) {
  <div class="empty-state">
    {{ 'inventory.productDetails.empty' | translate }}
  </div>
} @else {
  <div class="product-details">
    <div class="table-wrapper">
      <table mat-table [dataSource]="productDetails()" class="full-width-table" matSort>
        @for (column of columnsConfig; track column.name) {
          <ng-container [matColumnDef]="column.name">
            <th [class]="column.headerClass" mat-header-cell *matHeaderCellDef>
              {{ column.label | translate }}
            </th>

            <td [class]="column.cellClass" mat-cell *matCellDef="let detail">
              {{ detail[column.name] || '-' }}
            </td>
          </ng-container>
        }

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
}
